import ProfileMenuHeader from './ProfileMenuHeader';
import ProfileMenuStats from './ProfileMenuStats';
import ProfileMenuLogoutButton from './ProfileMenuLogoutButton';
import ProfileMenuFooter from './ProfileMenuFooter';

const ProfileMenuPanel = ({
	userInitial,
	displayName,
	email,
	isSavingName,
	nameError,
	onNameChange,
	onNameBlur,
	onNameKeyDown,
	tokenCount,
	planExpiry,
	onLogout,
	isLoggingOut,
	translations,
}) => (
	<>
		<ProfileMenuHeader
			userInitial={userInitial}
			displayName={displayName}
			email={email}
			isSavingName={isSavingName}
			nameError={nameError}
			onNameChange={onNameChange}
			onNameBlur={onNameBlur}
			onNameKeyDown={onNameKeyDown}
			displayNameLabel={translations.displayName}
		/>
		<ProfileMenuStats
			tokenCount={tokenCount}
			planExpiry={planExpiry}
			tokensLabel={translations.tokens}
			planValidUntilLabel={translations.planValidUntil}
		/>
		<ProfileMenuLogoutButton
			onLogout={onLogout}
			isLoggingOut={isLoggingOut}
			logOutLabel={translations.logOut}
			loggingOutLabel={translations.loggingOut}
		/>
		<ProfileMenuFooter
			privacyPolicyLabel={translations.privacyPolicy}
			termsOfUseLabel={translations.termsOfUse}
			supportLabel={translations.supportLabel}
			supportEmail={translations.supportEmail}
		/>
	</>
);

export default ProfileMenuPanel;
